<template>
    <div class="home">
        <div class="placeholder"></div>
        <div class="home-content home-warp">
            <div class="price-warp">
                <div class="price">
                    <span>${{totalamount}}</span>
                </div>
                <div class="price1">
                    <span>+${{dayamount}}</span>
                    <i>{{$t('home.dailyEarnings')}}</i>
                </div>
            </div>
            <div class="price-btn" @click="recharge()">
                {{$t('home.topUp')}} <img src="../../assets/img/home/arrow.png" alt="">
            </div>

            <div class="card-item">
                <img src="../../assets/img/home/img1.png" alt="">
                <div class="card-item-footer">
                    <div class="card-item-footer-l">
                        矿机 + 数据盒子 $ 335 U
                    </div>
                    <div class="card-item-footer-btn">
                        <div @click="buy(1)">
                            {{$t('home.buy')}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-item">
                <img src="../../assets/img/home/img2.png" alt="">
                <div class="card-item-footer">
                    <div class="card-item-footer-l">
                        矿机 $ <b>300</b> U
                    </div>
                    <div class="card-item-footer-btn">
                        <div @click="buy(2)" >
                            {{$t('home.buy')}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-item">
                <img src="../../assets/img/home/img3.png" alt="">
                <div class="card-item-footer">
                    <div class="card-item-footer-l">
                        数据盒 $ <b>35</b> U
                    </div>
                    <div class="card-item-footer-btn">
                        <div @click="buy(3)">
                            {{$t('home.buy')}}
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <Popup v-model="show" position="bottom" get-container="#app">
            <div class="buy-box">
                <div class="buy-title">
                    {{$t('home.popup.buy')}}
                    <img src="../../assets/img/home/close.png" @click="show = false" alt="">
                </div>
                <div class="buy-card">
                    <img :src="logoimg" alt="">
                    <div class="text">
                        {{remark}}
                    </div>
                    <div class="amount">
                        <div class="price">
                            <span>
                                {{totalprice}}
                            </span>
                            <div>
                                {{$t('home.popup.totalAmount')}} (USDT)
                            </div>
                        </div>
                        <div class="num">
                            <img @click="minus" src="../../assets/img/home/minus.png" alt="">
                            <Field v-model="value" />
                            <img @click="add" src="../../assets/img/home/add.png" alt="">
                        </div>
                    </div>

                    <div class="buy-block" >
                        <div class="buy-block-title" >
                            <span class="label" >{{$t('home.popup.wallet')}}</span>
                            <span class="price" >${{value1}}</span>
                        </div>
                        <Field class="buy-block-ipt" :label="$t('home.popup.pls')" v-model="input1" />
                    </div>

                    
                    <div class="buy-block" >
                        <div class="buy-block-title" >
                            <span class="label" >{{$t('home.popup.revenue')}}</span>
                            <span class="price" >${{value2}}</span>
                        </div>
                        <Field class="buy-block-ipt" :label="$t('home.popup.pls')" v-model="input2" />
                    </div>

                    
                    <div class="buy-block" >
                        <div class="buy-block-title" >
                            <span class="label" >{{$t('home.popup.config')}} <i>*{{$t('home.popup.most')}}:{{maxamount}}U</i></span>
                            <span class="price" >${{value3}}</span>
                        </div>
                        <Field class="buy-block-ipt" :label="$t('home.popup.pls')" v-model="input3" />
                    </div>

                    <div class="buy-btn" @click="trueBuy()" >{{$t('home.popup.confirmPurchase')}}</div>
                </div>
            </div>
        </Popup>


        <Popup v-model="recommendShow" :close-on-click-overlay="false" class="home-recommend-box" get-container="#app" position="center">
            <div class="home-recommend" >
                <div class="close">
                    <!-- <img @click="recommendShow = false" src="../../assets/img/home/close.png" alt=""> -->

                </div>
                <div class="title" >
                    {{$t('home.popup.plsDes')}} UID
                </div>
                    <Field class="ipt" v-model="value4" />
                    <div class="btn" @click="bindUser()" >
                        {{$t('home.popup.confirm')}}
                    </div>
            </div>
        </Popup>
    </div>
</template>

<script>
import {
    Field,
    Swipe,
    SwipeItem,
    Circle,
    Tab,
    Tabs,
    Popup,
    Progress,
    Button,
} from "vant";
import { copyToClipboard } from "@/utils";
import NumberScroll from "@/components/NumberScroll.vue";
import SplitText from "@/components/SplitText/SplitText.vue";
import ShinyText from "@/components/ShinyText/ShinyText.vue";
import AnimatedContent from "@/components/AnimatedContent/AnimatedContent.vue";
import FadeContent from "@/components/FadeContent/FadeContent.vue";


import axios from 'axios'
import contractaa from '../contract/index.js'

export default {
    name: "home",
    components: {
        SplitText,
        ShinyText,
        AnimatedContent,
        FadeContent,
        Field,
        Swipe,
        SwipeItem,
        Tab,
        VanCircle: Circle,
        Tabs,
        Popup,
        Progress,
        Button,
        NumberScroll,
    },
    data() {
        return {
            //购买数量
            value: "1",
            show: false,
            recommendShow: false,
            value1: '0',
            value2:'0',
            value3: '0',
            //推荐人UID
            value4: '',
            totalamount:0,
            dayamount:0,
            totalprice:0,
            remark:'',
            input1:'0',
            input2:'0',
            input3:'0',
            productid:0,
            logoimg:require('@/assets/img/home/positioning1.png'),
            maxamount:0
            
        };
    },
    computed: {},
    
    methods: {
        minus() {
            if(this.value > 1 && this.productid!=1 && this.productid!=2) {
                this.value--
            }else{
                return;
            }
            if(this.productid == 1){
                return;
                this.totalprice = this.value * 335;
            }else if(this.productid == 2){
                return;
                this.totalprice = this.value * 300;
            }else if(this.productid == 3){
                this.totalprice = this.value * 35;
            }
            this.maxamount = this.totalprice*0.3
        },
        add() {
            
            if(this.productid == 1){
                this.$toast.fail("矿机一次只可以购买一台")
                return;
                this.value++
                this.totalprice = this.value * 335;
            }else if(this.productid == 2){
               
                this.$toast.fail("矿机一次只可以购买一台")
                return;
                this.value++
                this.totalprice = this.value * 300;
            }else if(this.productid == 3){
                this.value++
                this.totalprice = this.value * 35;
            }
            this.maxamount = this.totalprice*0.3
        },
        bindUser(){
            let that = this;
            let _token = this.$store.state.loginToken
            _token = encodeURIComponent(_token)
            let memberno = that.value4

           
            axios.post(contractaa.APIURL+'?cmd=binduser','token='+ _token+'&uid='+memberno).then(function (response) {
            if (response.status === 200) {
                    if(response.data.Status){
                        that.recommendShow = false;
                        that.$toast.success(response.data.Message);
                    }
                    else{
                       that.recommendShow = true; 
                       that.$toast.fail(response.data.Message);
                    }
                }
            })
        },
        buy(v){
            this.show =  true
            if(v==1){
                this.remark ='矿机 + 数据盒'
                this.logoimg = require('@/assets/img/home/positioning1.png')
                this.totalprice = 335
                this.productid = 1
            }else if(v==2){
                this.remark='矿机'
                this.logoimg = require('@/assets/img/home/positioning2.png')
                this.totalprice = 300
                this.productid = 2
            }else if(v==3){
                this.remark='数据盒'
                this.logoimg = require('@/assets/img/home/positioning3.png')
                this.totalprice = 35
                this.productid = 3
            }
            this.maxamount = this.totalprice*0.3
        },
        trueBuy(){
            let that = this
            let _token = this.$store.state.loginToken
            _token = encodeURIComponent(_token)
            let _productid = that.productid
            let _value = that.value
            let _wallet1 = that.input1
            let _wallet2 = that.input2
            let _wallet3 = that.input3
            //that.$toast.success("产品ID:"+_productid+",数量："+_value+",1:"+_wallet1+",2:"+_wallet2+",3:"+_wallet3+"");
            let _postdata = 'token='+ _token+'&productid='+_productid+'&nums='+_value+'&wallet1='+_wallet1+'&wallet2='+_wallet2+'&wallet3='+_wallet3
            axios.post(contractaa.APIURL+'?cmd=buy',_postdata).then(function (response) {
            if (response.status === 200) {
                if(response.data.Status){
                        that.show =  false
                        that.$toast.success("购买成功");
                        that.$router.push({name: 'mining' });

                    }else{
                        that.$toast.fail(response.data.Message)
                    }
                }
            })
        },
        recharge(){
            let that = this;
            let _token = this.$store.state.loginToken
            _token = encodeURIComponent(_token)
            axios.post(contractaa.APIURL+'?cmd=addre','token='+ _token).then(function (response) {
            if (response.status === 200) {
                    if(response.data.Status){
                        let _vlist = response.data.Message
                        //console.log(_vlist)
                        window.location.href=_vlist;
                    }

                }
            })
        },
        getInfo(){
            let that = this;
            let _token = this.$store.state.loginToken
            _token = encodeURIComponent(_token)
            axios.post(contractaa.APIURL+'?cmd=home','token='+ _token).then(function (response) {
            if (response.status === 200) {
                    if(response.data.Data.rememberno.length<2){
                        that.recommendShow = true;
                    }else{
                        that.recommendShow = false;
                    }
                    that.totalamount = response.data.Data.totalAmount
                    that.dayamount = response.data.Data.daystatic + response.data.Data.daydynamic
                    that.value1 = response.data.Data.wallet1
                    that.value2 = response.data.Data.wallet2
                    that.value3 = response.data.Data.wallet3
                }
            })
        }
    },
    mounted() {
        let timer = setInterval(async () => {
            if (true) {
                this.getInfo()
                clearInterval(timer)
            }
        }, 500);
    },
};
</script>

<style lang="less" scoped>
.home {
    position: relative;

    .placeholder {
        // height: 50px;
    }

    .home-warp {
        padding: 0 20px;
    }

    &-content {

        .price-warp {
            margin-top: 30px;
            margin-bottom: 30px;
            text-align: center;

            .price {
                line-height: 42px;
                color: #FFFFFF;
                font-size: 36px;
                font-weight: bold;
                font-family: DINAlternate, DINAlternate;

                i {
                    font-size: 16px;
                    font-style: normal;
                }
            }

            .price1 {
                font-size: 12px;
                color: #51AC06;
                line-height: 17px;

                i {
                    margin-left: 4px;
                    font-style: normal;
                    font-size: 12px;
                    color: #484849;
                    line-height: 17px;
                }
            }
        }

        .price-btn {
            margin-bottom: 30px;
            background: url('../../assets/img/home/btn-bg.png') no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #FFFFFF;
            font-size: 14px;
            line-height: 14px;
            height: 46px;

            >img {
                margin-left: 7px;
                width: 14px;
                height: 14px;
            }
        }

        .card-item {
            min-height: 194px;
            padding: 10px;
            margin-bottom: 15px;

            >img {
                height: 110px;
                width: 100%;
            }

            &-footer {
                display: flex;
                justify-content: space-between;
                margin-top: 15px;

                &-l {
                    width: 210px;
                    height: 44px;
                    font-size: 14px;
                    line-height: 22px;
                    color: #FFFFFF;
                }

                &-btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    >div {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: #FFFFFF;
                        border-radius: 25px;
                        height: 34px;
                        min-width: 76px;
                        color: #000000;
                        font-size: 14px;
                        line-height: 20px;
                    }
                }
            }
        }

    }

}
</style>
<style lang="less">
.buy-box {
    background: #1B1C1E;
    .buy-title {
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60px;
        position: relative;

        >img {
            position: absolute;
            right: 15px;
            top: 15px;
            width: 26px;
            height: 26px;
        }
    }

    .buy-card {
        padding: 0 15px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        >img {
            width: 267.35px;
            height: 150px;
        }

        .text {
            margin-top: 15px;
            margin-bottom: 15px;
            width: 100%;
            font-size: 14px;
            line-height: 22px;
            color: #FFFFFF;
        }

        .amount {
            width: 100%;
            display: flex;
            margin-bottom: 21px;
            justify-content: space-between;
            align-items: center;
            .price {
                span {
                    color: #FFFFFF;
                    font-size: 32px;
                    font-weight: bold;
                    font-family: DINAlternate, DINAlternate;
                    line-height: 37px;

                    i {
                        font-size: 14px;
                        font-style: normal;
                    }
                }

                >div {
                    font-size: 12px;
                    color: #838383;
                    font-weight: 400;
                    line-height: 12px;
                }

            }

            .num {
                padding: 3px;
                width: 125px;
                display: flex;
                justify-content: space-between;

                >img {
                    width: 32px;
                    height: 32px;
                }

                .van-cell {
                    width: 50px;
                    background: #0F0F0F;
                    padding: 0;
                    height: 32px;

                    &::after {
                        display: none;
                    }

                    input {
                        height: 32px;
                        color: #FFFFFF;
                        text-align: center;
                        font-size: 16px;
                        font-weight: 500;
                    }
                }
            }
        }

        .buy-block{
            width: 100%;
            margin-bottom: 16px;
            &-title {
                margin-bottom: 6px;
                display: flex;
                justify-content: space-between;
                .label {
                    color: #C6C6C6;
                    font-size: 14px;
                    line-height: 22px;
                    i {
                        margin-left: 6px;
                        font-size: 12px;
                        font-style: normal;
                        color: #FFFFFF;
                    }
                }
                .price {
                    color: #FFFFFF;
                    font-size: 12px;
                    line-height: 12px;
                }
            }
            &-ipt {
                background: #0F0F0F;
                border-radius: 10px;
                border: 1px solid #313439;
                height: 50px;
                padding: 0 15px;
                display: flex;
                align-items: center;
                .van-field__label{
                    width: auto;
                    font-size: 14px;
                    line-height: 22px;
                    color: #484849;
                }
                input {
                    text-align: right;
                    color: #FFFFFF;
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 22px;
                }
            }
        }

        .buy-btn {
            margin-bottom: 35px;
            height: 50px;
            background: #FFFFFF;
            border-radius: 25px;
            font-size: 14px;
            color: #000000;
            line-height: 20px;
            font-weight: 500;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            margin-top: 15px;
        }
    }
}
.home-recommend-box {
    background: transparent;
    -webkit-backdrop-filter: blur(17px);
    backdrop-filter: blur(17px);
    border-radius: 16px;
}
.home-recommend{
    width: 305px;
    height: 208px;
    background: url('../../assets/img/home/card-bg.png') no-repeat;
    background-size: 100% 100%;
    padding: 16px 20px 0;
    .title {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        color: #FFFFFF;
        text-align: center;
        position: relative;
        margin-bottom: 28px;
       
    }
    .close {
        position: absolute;
            right: 15px;
            top: 15px;
            z-index: 2;
        img {
           
            width: 26px;
            height: 26px;
        }
    }
    .ipt{
        background: #0F0F0F;
        border-radius: 10px;
        border: 1px solid #313439;
        height: 50px;
        padding: 0 15px;
        display: flex;
        align-items: center;
        input {
            color: #FFFFFF;
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
        }
        &::after{
            display: none;
        }
    }
    .btn {
        cursor: pointer;
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #FFFFFF;
        border-radius: 25px;
        color: #000000;
        font-size: 14px;
        font-weight: 500;
        line-height: 12px;
        height: 50px;
    }
}
</style>